import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Navigate, Outlet, useNavigate } from 'react-router-dom'
import { useMetaStore } from '../store/MetaStore'

const ProtectedRoute = () => {
  const isAdmin = useMetaStore((state) => state.isAdmin)
  const navigate = useNavigate()
  const [isInterceptorSetup, setIsInterceptorSetup] = useState(false)
  const setErrorMsg = useMetaStore((state) => state.setErrorMsg)

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          setErrorMsg('You are not authorized to perform that action.')
          navigate('/error')
        }
        return Promise.reject(error)
      }
    )

    setIsInterceptorSetup(true)

    return () => {
      axios.interceptors.response.eject(interceptor)
    }
  }, [navigate, setErrorMsg])

  if (!isAdmin) {
    return <Navigate to="/login" replace />
  }

  if (!isInterceptorSetup) {
    return null
  }

  return <Outlet />
}

export default ProtectedRoute
